import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {Button, IconButton, Tooltip} from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import ViewIcon from '@material-ui/icons/Search'
import { PURPLE_COLOR } from "../constants";

export default class Listofattachments extends Component {

  handleRowClick(attachment){
    const callback = this.props.handleRowClick;
    if(callback){setTimeout(callback,10,attachment);}
  }

  handleRemoveRowClick(attachment){
    const callback = this.props.handleRemoveRowClick;
    if(callback){setTimeout(callback,10,attachment);}
  }

  render() {
    var tblattachments = [];
    if(this.props.tblattachments){tblattachments = this.props.tblattachments;
    return (
      <div>

        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell style={{ minWidth: 100 }}>File Name</TableCell>

                <TableCell style={{ minWidth: 100 }}>Options</TableCell>


              </TableRow>
            </TableHead>
            <TableBody>

              {tblattachments.map((item,index)=>{

                let filenameAdj = item.filename.replace(".pdf","");
                return(
                  <TableRow role="checkbox" fullWidth tabIndex={-1} hover style={{cursor:'pointer'}} onClick={()=>this.handleRowClick(item)}>
                    <TableCell>{filenameAdj}</TableCell>

                    <IconButton aria-label="delete" onClick={()=>this.handleRowClick(item)}>
                      <Tooltip title={'View PDF'}>
                        <ViewIcon />
                      </Tooltip>

                    </IconButton>

                    <IconButton aria-label="delete" onClick={()=>this.handleRemoveRowClick(item)}>
                      <Tooltip title={'Remove PDF'}>
                      <DeleteIcon />
                      </Tooltip>
                    </IconButton>
                  </TableRow>
                )
              })}

            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  }
}}
